import type { ILandingPage } from '@/interfaces';
import { NextSeo } from 'next-seo';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export interface LandingPageSEOHeadProps {
  entry: ILandingPage;
}

const LandingPageSEOHead: React.FC<LandingPageSEOHeadProps> = ({ entry }) => {
  const { origin } = publicRuntimeConfig;
  const { landingPageSeo, slug = '', supportedLocales } = entry;

  // Strip locale prefix regardless of format: "en/track-dhl" → "track-dhl", "en-US/track-dhl" → "track-dhl"
  const baseSlug = slug.replace(/^[^/]+\//, '');

  const languageAlternates = [
    ...(supportedLocales ?? []).map((locale) => ({
      hrefLang: locale,
      href: `${origin}/${locale}/${baseSlug}`,
    })),
    {
      hrefLang: 'x-default',
      href: `${origin}/en/${baseSlug}`,
    },
  ];

  const pageUrl = `${origin}/${slug}`;

  return (
    <>
      <NextSeo
        title={landingPageSeo?.metaTitle}
        description={landingPageSeo?.metaDescription}
        canonical={pageUrl}
        openGraph={{
          url: pageUrl,
          title: landingPageSeo?.metaTitle,
          description: landingPageSeo?.metaDescription,
          images: [{ url: `${origin}/images/parcel_monitor_og_image.png` }],
          type: 'website',
        }}
        additionalMetaTags={[
          {
            name: 'robots',
            content: 'index, follow',
          },
        ]}
        additionalLinkTags={[
          {
            rel: 'dns-prefetch',
            href: '//www.google-analytics.com',
          },
          {
            rel: 'dns-prefetch',
            href: '//cdn.contentful.com',
          },
          {
            rel: 'dns-prefetch',
            href: '//images.ctfassets.net',
          },
        ]}
        languageAlternates={languageAlternates}
      />
    </>
  );
};

export default LandingPageSEOHead;
